export enum WizStatusEnum {
  NOT_STARTED = 'not_started',
  TEST_STARTED = 'test_started',
  COMPLETED = 'completed',
}
